import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, Stack, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';

import ControlWithLabel from 'src/components/ControlWithLabel';
import PageFooter from 'src/components/PageFooter';
import PageHeader from 'src/components/PageHeader';
import StyledLinearProgressBar from 'src/components/StyledLinearProgressBar';
import { useOnboardingWorkflow } from 'src/contexts/OnboardingWorkflowContext';
import { selectOnboardingState } from 'src/store/slices/onboardingSlice';

export const Route = createFileRoute('/(app)/onboarding/confirm-role')({
    component: ConfirmRoleComponent,
});

function ConfirmRoleComponent() {
    const { careRecipient, onboardingUser } = useSelector(selectOnboardingState);

    const { progress, previousStep, canGoBack, nextStep, isProcessing } = useOnboardingWorkflow();
    const [isRoleConfirmed, setIsRoleConfirmed] = useState(false);

    return (
        <>
            <PageHeader
                hideBackButton={!canGoBack}
                onBack={canGoBack ? previousStep : undefined}
                hideActionButton
            >
                <StyledLinearProgressBar value={progress.percentage} />
            </PageHeader>
            <Stack sx={{ gap: 4, mb: 2.5 }}>
                <Typography variant="h1" sx={{ fontWeight: 'bold' }}>
                    Confirm Your Role
                </Typography>
                <Typography variant="body1">
                    I,{' '}
                    <strong>
                        {onboardingUser?.firstName} {onboardingUser?.lastName}
                    </strong>
                    , confirm that I am{' '}
                    <strong>
                        {careRecipient?.firstName} {careRecipient?.lastName}
                    </strong>
                    {}
                    &apos;s personal representative and have the legal authority to act on their
                    behalf as necessary to set up and manage the Sage services, including accessing
                    or disclosing their protected health information.
                </Typography>

                <ControlWithLabel
                    label="I confirm that I have the legal authority to act on this person's behalf."
                    checked={isRoleConfirmed}
                    onChange={() => setIsRoleConfirmed(!isRoleConfirmed)}
                />
            </Stack>
            <PageFooter>
                <Button
                    variant="contained"
                    disabled={!isRoleConfirmed}
                    color="primary"
                    fullWidth
                    onClick={nextStep}
                    loading={isProcessing}
                >
                    Continue
                </Button>
            </PageFooter>
        </>
    );
}
